// extracted by mini-css-extract-plugin
var _1 = "GroupingFormValueItemAnswer_actions__cb576";
var _2 = "GroupingFormValueItemAnswer_active__de13d";
var _3 = "GroupingFormValueItemAnswer_floatingHeader__fdb9c";
var _4 = "GroupingFormValueItemAnswer_header__5223e";
var _5 = "GroupingFormValueItemAnswer_icon__66773";
var _6 = "GroupingFormValueItemAnswer_icons__9c174";
var _7 = "GroupingFormValueItemAnswer_img__35bdb";
var _8 = "GroupingFormValueItemAnswer_root__2070c";
var _9 = "GroupingFormValueItemAnswer_title__1f3fc";
export { _1 as "actions", _2 as "active", _3 as "floatingHeader", _4 as "header", _5 as "icon", _6 as "icons", _7 as "img", _8 as "root", _9 as "title" }
